// ─────────────────────────────────────────────────────────────────────────────
// Logo de l'application (fichiers dans public/). Pour un autre client,
// remplacer les fichiers ou ces chemins — rien d'autre.
// ─────────────────────────────────────────────────────────────────────────────

const PUBLIC = process.env.PUBLIC_URL ?? "";

/** Logo complet (symbole + « AVDASH »), fond transparent. */
export const LOGO_URL = `${PUBLIC}/logoavdash.png`;

/** Symbole seul, carré et transparent : petites tailles (pied de page, puces). */
export const LOGO_ICON_URL = `${PUBLIC}/avdash-icon-64.png`;

export const BRAND_NAME = "AvDash";
